<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <drivers-edit-form @on-submit="onDriverEditSubmit"></drivers-edit-form>
    </div>
    <div class="md-layout-item md-size-100">
      <driver-edit-avatar-upload
        v-if="this.$route.params.id !== undefined"
        label-picker="Foto kiezen"
        label-upload="foto uploaden"
      ></driver-edit-avatar-upload>
    </div>
    <div class="md-layout-item md-size-100">
      <drivers-edit-periods-available
        v-if="this.$route.params.id !== undefined"
      ></drivers-edit-periods-available>
    </div>
    <drivers-periods-unavailable-overview
      v-if="this.$route.params.id !== undefined"
    ></drivers-periods-unavailable-overview>
  </div>
</template>
<script>
import DriversEditForm from "./DriversEditForm.vue";
import DriversPeriodsUnavailableOverview from "./DriversPeriodsUnavailableOverview";
import DriversEditPeriodsAvailable from "@/pages/Dashboard/Drivers/DriversEditPeriodsAvailable";
import DriverEditAvatarUpload from "@/pages/Dashboard/Users/UserEditAvatarUpload";

export default {
  components: {
    DriversPeriodsUnavailableOverview,
    DriversEditForm,
    DriversEditPeriodsAvailable,
    DriverEditAvatarUpload
  },
  data() {
    return {
      driverEditModel: {}
    };
  },
  methods: {
    onDriverEditSubmit(model) {
      this.driverEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'users/' + this.userEditModel.id, Object.assign(this.userEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
